import _extends from "@babel/runtime-corejs3/helpers/extends";
import _sliceInstanceProperty from "@babel/runtime-corejs3/core-js/instance/slice";
import { useInstance, createRef } from 'intact-vue-next';
import { useState } from '../../hooks/useState';
import { Pagination } from '../pagination';
import { isObject } from 'intact-shared';
import { useReceive } from '../../hooks/useReceive';
var defaultPagination = Pagination.defaults();
export function usePagination() {
  var instance = useInstance();
  var data = useState(instance.get('data'));
  var value = useState(defaultPagination.value);
  var limit = useState(defaultPagination.limit);
  var paginationRef = createRef(); // for unit test
  useReceive(['data', 'pagination'], function () {
    handleData();
  });
  function handleData() {
    var _instance$get = instance.get(),
      _data = _instance$get.data,
      pagination = _instance$get.pagination;
    if (!_data) {
      data.set(undefined);
      return;
    }
    if (!pagination) {
      data.set(_data);
      return;
    }
    if (isObject(pagination)) {
      if (pagination.value) {
        value.set(pagination.value);
      }
      if (pagination.limit) {
        limit.set(pagination.limit);
      }
    }
    updateDataByPage();
  }
  function updateDataByPage() {
    var _instance$get2 = instance.get(),
      _data = _instance$get2.data;
    var index = (value.value - 1) * limit.value;
    data.set(_sliceInstanceProperty(_data).call(_data, index, index + limit.value));
  }
  function onChange(data) {
    var _instance$get3 = instance.get(),
      pagination = _instance$get3.pagination;
    value.set(data.value);
    limit.set(data.limit);
    updateDataByPage();
    if (isObject(pagination)) {
      instance.set('pagination', _extends({}, pagination, {
        value: value.value,
        limit: limit.value
      }));
    }
    instance.trigger('page', data);
  }
  return {
    data: data,
    value: value,
    limit: limit,
    onChange: onChange,
    paginationRef: paginationRef
  };
}